import React, { useState } from "react";
import { Link } from "react-router-dom";
import { scroller } from "react-scroll";
import logo from "../assets/images/frcsit-logo.png";
import useMobile from "../hooks/useMobile";
import { useShowMenu } from "../context/ShowMenuContext";
import { useCompanyDetailsContext } from "../context/CompanyDetailsContext";
import { formatUrl } from "../exports/functions";

const MobileNav = () => {
  const mobile = useMobile();
  const { companyDetailsData } = useCompanyDetailsContext();
  const { showMenu, setShowMenu } = useShowMenu();
  const [activeDropdowns, setActiveDropdowns] = useState<string[]>([]);

  const toggleDropdown = (section: string) => {
    setActiveDropdowns((prev) =>
      prev.includes(section)
        ? prev.filter((item) => item !== section)
        : [...prev, section]
    );
  };

  const linkClicker = (path: string) => {
    const pathLocation = window.location.pathname.includes(path);
    if (!pathLocation) {
      window.scrollTo(0, 0);
    } else {
      scroller.scrollTo("toTop", {
        duration: 500,
        smooth: true,
      });
    }
    setShowMenu(false);
    setActiveDropdowns([]);
  };
  return (
    <>
      <div className={`mobile-nav__wrapper ${showMenu && "expanded"}`}>
        <div
          className="mobile-nav__overlay mobile-nav__toggler"
          onClick={() => {
            setShowMenu(false);
            setActiveDropdowns([]);
          }}
        ></div>

        <div className="mobile-nav__content">
          <span
            className="mobile-nav__close mobile-nav__toggler"
            onClick={() => {
              setShowMenu(false);
              setActiveDropdowns([]);
            }}
          >
            <i className="fa fa-times"></i>
          </span>

          <div className="logo-box">
            <a href="/" aria-label="logo image">
              <img height={mobile ? "40" : "60"} src={logo} alt="logo" />
            </a>
          </div>

          <div className="mobile-nav__container">
            <ul className="main-menu__list">
              <li className="dropdown megamenu">
                <Link to="/" onClick={() => linkClicker("")}>
                  Home
                </Link>
              </li>
              <li className="dropdown megamenu">
                <Link to="/about" onClick={() => linkClicker("about")}>
                  About
                </Link>
              </li>
              <li className="dropdown megamenu">
                <Link to="/council" onClick={() => linkClicker("council")}>
                  The Council
                </Link>
              </li>
              <li className="dropdown">
                <Link
                  to="#"
                  onClick={() => toggleDropdown("news-events")}
                  className={
                    activeDropdowns.includes("news-events") ? "expanded" : ""
                  }
                >
                  News & Events{" "}
                  <button
                    aria-label="dropdown toggler"
                    className={
                      activeDropdowns.includes("news-events") ? "expanded" : ""
                    }
                  >
                    <i className="fa fa-angle-down"></i>
                  </button>
                </Link>
                <ul
                  className={
                    activeDropdowns.includes("news-events")
                      ? "sub-expanded"
                      : ""
                  }
                >
                  <li>
                    <Link to="/events" onClick={() => linkClicker("events")}>
                      Events
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/news-letter"
                      onClick={() => linkClicker("news-letter")}
                    >
                      News Letter
                    </Link>
                  </li>
                </ul>
              </li>
              <li className="dropdown">
                <Link
                  to="#"
                  onClick={() => toggleDropdown("members-area")}
                  className={
                    activeDropdowns.includes("members-area") ? "expanded" : ""
                  }
                >
                  Members Area{" "}
                  <button
                    aria-label="dropdown toggler"
                    className={
                      activeDropdowns.includes("members-area") ? "expanded" : ""
                    }
                  >
                    <i className="fa fa-angle-down"></i>
                  </button>
                </Link>
                <ul
                  className={
                    activeDropdowns.includes("members-area")
                      ? "sub-expanded"
                      : ""
                  }
                >
                  <li>
                    <Link
                      to="/become-a-member"
                      onClick={() => linkClicker("become-a-member")}
                    >
                      Become a Member
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/benefits-of-member"
                      onClick={() => linkClicker("benefits-of-member")}
                    >
                      Benefits of a Member
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/list-of-all-member"
                      onClick={() => linkClicker("list-of-all-member")}
                    >
                      List of All Members
                    </Link>
                  </li>
                </ul>
              </li>
              <li className="dropdown">
                <Link
                  to="#"
                  onClick={() => toggleDropdown("surgical-domains")}
                  className={
                    activeDropdowns.includes("surgical-domains")
                      ? "expanded"
                      : ""
                  }
                >
                  Surgical Domains{" "}
                  <button
                    aria-label="dropdown toggler"
                    className={
                      activeDropdowns.includes("surgical-domains")
                        ? "expanded"
                        : ""
                    }
                  >
                    <i className="fa fa-angle-down"></i>
                  </button>
                </Link>
                <ul
                  className={
                    activeDropdowns.includes("surgical-domains")
                      ? "sub-expanded"
                      : ""
                  }
                >
                  <li className="dropdown">
                    <Link
                      to="#"
                      onClick={() => toggleDropdown("overview")}
                      className={
                        activeDropdowns.includes("overview") ? "expanded" : ""
                      }
                    >
                      Overview
                      <button
                        aria-label="dropdown toggler"
                        className={
                          activeDropdowns.includes("overview") ? "expanded" : ""
                        }
                      >
                        <i className="fa fa-angle-down"></i>
                      </button>
                    </Link>
                    <ul
                      className={
                        activeDropdowns.includes("overview")
                          ? "sub-expanded"
                          : ""
                      }
                    >
                      <li>
                        <Link
                          to="/types-of-facial-plastic-surgery"
                          onClick={() =>
                            linkClicker("types-of-facial-plastic-surgery")
                          }
                        >
                          Types of Facial Plastic Surgery
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/who-is-a-facial-plastic-surgeon"
                          onClick={() =>
                            linkClicker("who-is-a-facial-plastic-surgeon")
                          }
                        >
                          Who is a Facial Plastic Surgeon
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li className="dropdown">
                    <Link
                      to="#"
                      onClick={() => toggleDropdown("nose")}
                      className={
                        activeDropdowns.includes("nose") ? "expanded" : ""
                      }
                    >
                      Nose{" "}
                      <button
                        aria-label="dropdown toggler"
                        className={
                          activeDropdowns.includes("nose") ? "expanded" : ""
                        }
                      >
                        <i className="fa fa-angle-down"></i>
                      </button>
                    </Link>
                    <ul
                      className={
                        activeDropdowns.includes("nose") ? "sub-expanded" : ""
                      }
                    >
                      <li>
                        <Link
                          to="/rhinoplasty"
                          onClick={() => linkClicker("rhinoplasty")}
                        >
                          Rhinoplasty
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li className="dropdown">
                    <Link
                      to="#"
                      onClick={() => toggleDropdown("eyelids")}
                      className={
                        activeDropdowns.includes("eyelids") ? "expanded" : ""
                      }
                    >
                      Eyelids{" "}
                      <button
                        aria-label="dropdown toggler"
                        className={
                          activeDropdowns.includes("eyelids") ? "expanded" : ""
                        }
                      >
                        <i className="fa fa-angle-down"></i>
                      </button>
                    </Link>
                    <ul
                      className={
                        activeDropdowns.includes("eyelids")
                          ? "sub-expanded"
                          : ""
                      }
                    >
                      <li>
                        <Link
                          to="/lower-blepharoplasty"
                          onClick={() => linkClicker("lower-blepharoplasty")}
                        >
                          Lower Blepharoplasty
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/upper-blepharoplasty"
                          onClick={() => linkClicker("upper-blepharoplasty")}
                        >
                          Upper Blepharoplasty
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li className="dropdown">
                    <Link
                      to="#"
                      onClick={() => toggleDropdown("lifts")}
                      className={
                        activeDropdowns.includes("lifts") ? "expanded" : ""
                      }
                    >
                      Lifts{" "}
                      <button
                        aria-label="dropdown toggler"
                        className={
                          activeDropdowns.includes("lifts") ? "expanded" : ""
                        }
                      >
                        <i className="fa fa-angle-down"></i>
                      </button>
                    </Link>
                    <ul
                      className={
                        activeDropdowns.includes("lifts") ? "sub-expanded" : ""
                      }
                    >
                      <li>
                        <Link
                          to="/face-lift"
                          onClick={() => linkClicker("face-lift")}
                        >
                          Face Lift
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/fore-head-lift"
                          onClick={() => linkClicker("fore-head-lift")}
                        >
                          ForeHead Lift
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li className="dropdown">
                    <Link
                      to="#"
                      onClick={() => toggleDropdown("chin-ears")}
                      className={
                        activeDropdowns.includes("chin-ears") ? "expanded" : ""
                      }
                    >
                      Chin & Ears{" "}
                      <button
                        aria-label="dropdown toggler"
                        className={
                          activeDropdowns.includes("chin-ears")
                            ? "expanded"
                            : ""
                        }
                      >
                        <i className="fa fa-angle-down"></i>
                      </button>
                    </Link>
                    <ul
                      className={
                        activeDropdowns.includes("chin-ears")
                          ? "sub-expanded"
                          : ""
                      }
                    >
                      <li>
                        <Link
                          to="/mentoplasty"
                          onClick={() => linkClicker("mentoplasty")}
                        >
                          Mentoplasty
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/otoplasty"
                          onClick={() => linkClicker("otoplasty")}
                        >
                          Otoplasty
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li className="dropdown">
                    <Link
                      to="#"
                      onClick={() => toggleDropdown("skin")}
                      className={
                        activeDropdowns.includes("skin") ? "expanded" : ""
                      }
                    >
                      Skin
                      <button
                        aria-label="dropdown toggler"
                        className={
                          activeDropdowns.includes("skin") ? "expanded" : ""
                        }
                      >
                        <i className="fa fa-angle-down"></i>
                      </button>
                    </Link>
                    <ul
                      className={
                        activeDropdowns.includes("skin") ? "sub-expanded" : ""
                      }
                    >
                      <li>
                        <Link
                          to="/scar-revision"
                          onClick={() => linkClicker("scar-revision")}
                        >
                          Scar Revision
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/skin-cancer"
                          onClick={() => linkClicker("skin-cancer")}
                        >
                          Skin Cancer
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/skin-peels"
                          onClick={() => linkClicker("skin-peels")}
                        >
                          Skin Peels
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li className="dropdown">
                    <Link
                      to="#"
                      onClick={() => toggleDropdown("injectables")}
                      className={
                        activeDropdowns.includes("injectables")
                          ? "expanded"
                          : ""
                      }
                    >
                      Injectables
                      <button
                        aria-label="dropdown toggler"
                        className={
                          activeDropdowns.includes("injectables")
                            ? "expanded"
                            : ""
                        }
                      >
                        <i className="fa fa-angle-down"></i>
                      </button>
                    </Link>
                    <ul
                      className={
                        activeDropdowns.includes("injectables")
                          ? "sub-expanded"
                          : ""
                      }
                    >
                      <li>
                        <Link
                          to="/botulinum-toxin"
                          onClick={() => linkClicker("botulinum-toxin")}
                        >
                          Botulinum Toxin
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li className="dropdown">
                    <Link
                      to="#"
                      onClick={() => toggleDropdown("lipoplasty")}
                      className={
                        activeDropdowns.includes("lipoplasty") ? "expanded" : ""
                      }
                    >
                      Lipoplasty{" "}
                      <button
                        aria-label="dropdown toggler"
                        className={
                          activeDropdowns.includes("lipoplasty")
                            ? "expanded"
                            : ""
                        }
                      >
                        <i className="fa fa-angle-down"></i>
                      </button>
                    </Link>
                    <ul
                      className={
                        activeDropdowns.includes("lipoplasty")
                          ? "sub-expanded"
                          : ""
                      }
                    >
                      <li>
                        <Link
                          to="/fat-grafting"
                          onClick={() => linkClicker("fat-grafting")}
                        >
                          Fat Grafting
                        </Link>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <Link to="/gallery" onClick={() => linkClicker("gallery")}>
                  Gallery
                </Link>
              </li>
              <li>
                <Link to="/archive" onClick={() => linkClicker("archive")}>
                  Archive
                </Link>
              </li>
              <li>
                <Link to="/contact" onClick={() => linkClicker("contact")}>
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <ul className="mobile-nav__contact list-unstyled">
            <li>
              <i className="fa fa-phone-alt"></i>
              <a
                href={`tel:${companyDetailsData[0]?.attributes?.Phone_Number}`}
              >
                {companyDetailsData[0]?.attributes?.Phone_Number}
              </a>
            </li>
            <li>
              <i className="fa fa-envelope"></i>
              <a href={`mailto:${companyDetailsData[0]?.attributes?.Email}`}>
                {companyDetailsData[0]?.attributes?.Email}
              </a>
            </li>
          </ul>
          <div className="mobile-nav__top">
            <div className="mobile-nav__social">
              <a
                href={formatUrl(
                  companyDetailsData[0]?.attributes?.TwitterX_Link
                )}
                target="_blank"
                rel="noopener noreferrer"
                className="fab fa-twitter"
              >
                <span></span>
              </a>
              <a
                href={formatUrl(
                  companyDetailsData[0]?.attributes?.Facebook_Link
                )}
                target="_blank"
                rel="noopener noreferrer"
                className="fab fa-facebook-square"
              >
                <span></span>
              </a>
              <a
                href={formatUrl(
                  companyDetailsData[0]?.attributes?.Instagram_Link
                )}
                target="_blank"
                rel="noopener noreferrer"
                className="fab fa-instagram"
              >
                <span></span>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="search-popup">
        <div className="search-popup__overlay search-toggler"></div>

        <div className="search-popup__content">
          <form action="#">
            <label className="sr-only">search here</label>
            <input type="text" id="search" placeholder="Search Here..." />
            <button
              type="submit"
              aria-label="search submit"
              className="thm-btn"
            >
              <i className="icon-magnifying-glass"></i>
            </button>
          </form>
        </div>
      </div> */}
    </>
  );
};

export default MobileNav;
